module.exports = __webpack_public_path__ + "img/p2.b0154d2d.png";